import VueWrapper from '@/components/core/Vue/vue.wrapper';
import ClientFooterComponent from '@/components/vuetify/client-footer/client-footer.component';
import {Component} from 'vue-property-decorator';

@Component({
    components: {
        ClientFooterComponent,
    },
})
export default class PolicyLayoutComponent extends VueWrapper {
    public $refs!: {};

    public localeChange() {
        //
    }
}
